export const FETCH_CURRENT_REQUEST = 'FETCH_CURRENT_REQUEST';
export const FETCH_CURRENT_SUCCESS = 'FETCH_CURRENT_SUCCESS';
export const FETCH_CURRENT_FAILED = 'FETCH_CURRENT_FAILED';

export const SWITCH_TYPE = 'SWITCH_TYPE';


// WEBPACK FOOTER //
// ./src/store/constants.js